import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import ReactGA4 from 'react-ga4';
import { DesktopHeader2, NotConnected } from 'components';
import { AccountInfo, AccountHistory } from './components';
import { getGaUserType, useCurrentAddressInfo } from '@/hooks';
import style from './index.module.css';

const AccountPage = () => {
  const { t } = useTranslation();

  const { address, isVerified } = useCurrentAddressInfo();

  useEffect(() => {
    ReactGA4.event({
      category: 'View L2 Wallet',
      action: `L2 Wallet_${getGaUserType()}`,
    });
  }, []);

  return (
    <>
      <DesktopHeader2 title={t('Account.172ja5g')} />
      {address && isVerified ? (
        <div className={style.container}>
          <AccountInfo className={style.info} />
          <AccountHistory className={style.history} />
        </div>
      ) : (
        <NotConnected />
      )}
    </>
  );
};

export default AccountPage;
export * from './hooks';
